// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup__33S9c","popup--1":"Popup_popup--1__21U0r"};